import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../../../shared/blocks/blocks.types'
import { isWeb } from '@my/ui'

export const SearchBlockFragment: BlockFragment = {
  name: 'search',
  fragment: gql`
    fragment search on Search {
      id
      title
      blockType
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Search {
      id
      title
      blockType
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const SearchBlockType = 'search'

export const canRenderSearchBlock = (block: SearchBlock): boolean => {
  return isWeb
}

export interface SearchBlock extends BaseBlock {
  blockType: typeof SearchBlockType
  title?: string
  id: string
}
